/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Doc_Overridden_ByInputs */

const en_doc_overridden_by = /** @type {(inputs: Doc_Overridden_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changed by ${i?.name}`)
};

const pt_br2_doc_overridden_by = /** @type {(inputs: Doc_Overridden_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alterado por ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Changed by {name}" |
*
* @param {Doc_Overridden_ByInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_overridden_by = /** @type {((inputs: Doc_Overridden_ByInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Overridden_ByInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_overridden_by(inputs)
	return pt_br2_doc_overridden_by(inputs)
});